
import { defineComponent, PropType, createVNode } from 'vue';
import { Modal } from 'ant-design-vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { useService } from '@kaokei/use-vue-service';
import { ExamService } from '@/services/exam/exam.service';

import { QuestionDto } from '@/types';

import {
  value2label,
  QUESTION_TYPE,
  numberToLetter,
  formatDateToSecond,
  IS_QUESTION_TYPE_PROGRAM,
} from '@/utils';

import Image from './Image.vue';
import CustomAudio from './CustomAudio.vue';

import {
  EyeOutlined,
  EditOutlined,
  ClockCircleOutlined,
} from '@ant-design/icons-vue';

export default defineComponent({
  name: 'QuestionProgram',
  components: {
    Image,
    CustomAudio,
    EyeOutlined,
    EditOutlined,
    ClockCircleOutlined,
  },
  props: {
    question: {
      type: Object as PropType<QuestionDto>,
      default: () => ({}),
    },
    answerMode: {
      type: Boolean,
      default: false,
    },
    hasPaperAnswer: {
      type: Boolean,
    },
    markRecordData: {
      type: Object,
    },
  },
  setup(_, { emit }) {
    const examService = useService(ExamService);
    const showIde = () => {
      if (examService.answerOrderLimit && !examService.hasFinishedObjective) {
        // 判断当前客观题还有多少题没有，并提示开始做主观题后将不能再次修改和查看客观题。确定后就直接上报
        let leftCount = 0;
        examService.exam.questionsDtoList.forEach(item => {
          if (!IS_QUESTION_TYPE_PROGRAM(item.questionTypeId)) {
            item.questionDtoList.forEach(question => {
              if (question.questionStatus !== 'completed') {
                leftCount++;
              }
            });
          }
        });
        Modal.confirm({
          title:
            (leftCount ? `您当前还有${leftCount}道客观题未作答，` : '') +
            '确定要开始答主观题吗？',
          icon: createVNode(ExclamationCircleOutlined),
          content: '开始主观题答题后，客观题将不可查看和修改',
          okText: '确认',
          cancelText: '取消',
          onOk: () => {
            examService.applyFinishObjectiveRecord().then(() => {
              examService.hasFinishedObjective = 1;
              emit('show');
            });
          },
        });
      } else {
        emit('show');
      }
    };
    return {
      examService,
      QUESTION_TYPE,
      value2label,
      numberToLetter,
      showIde,
      formatDateToSecond,
    };
  },
});
